import { createFileRoute } from '@tanstack/react-router';
import {
  HelpDeskAdmin, SEVERITY_OPTIONS, STATUS_OPTIONS, type HelpDeskSearch,
} from '@/features/support/HelpDeskAdmin';

export const Route = createFileRoute('/_app/admin/help-desk')({
  // Filtri rapidi persistiti in URL: param assente = nessun filtro (URL pulito).
  validateSearch: (s: Record<string, unknown>): HelpDeskSearch => ({
    status: typeof s.status === 'string' && STATUS_OPTIONS.some((o) => o.value === s.status) ? s.status : undefined,
    severity: typeof s.severity === 'string' && SEVERITY_OPTIONS.some((o) => o.value === s.severity) ? s.severity : undefined,
  }),
  component: HelpDeskAdminPage,
});

function HelpDeskAdminPage() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <HelpDeskAdmin
      search={search}
      onSearchChange={(patch) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true })}
    />
  );
}
